import { ResponsiveContainer, AreaChart, Area, Tooltip, XAxis, YAxis } from 'recharts';

import colors from '@legacy/moon/particles/colors';

import { AreaGraphProps } from './types';
import { GraphContainer } from './styles';

const AreaGraph = ({
  data,
  dataMin,
  dataMax,
  color,
  customTooltip,
  colorID = 'colorAreaChart',
}: AreaGraphProps): JSX.Element => (
  <GraphContainer>
    <ResponsiveContainer width="99%" height="100%">
      <AreaChart data={data}>
        <defs>
          <linearGradient id={colorID} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={`#${color}`} stopOpacity={1} />
            <stop offset="95%" stopColor={`#${color}`} stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="date" hide />
        <YAxis domain={[dataMin ? dataMin * 0.999 : 'auto', dataMax ? dataMax * 1.001 : 'auto']} hide />
        <Tooltip content={customTooltip} cursor={false} />
        <Area
          type="monotone"
          dataKey="close"
          activeDot={{ stroke: `#${color}`, strokeWidth: 4.5, r: 5, fill: `${colors.moonlight0}` }}
          stroke={`#${color}`}
          fillOpacity={0.8}
          fill={`url(#${colorID})`}
        />
      </AreaChart>
    </ResponsiveContainer>
  </GraphContainer>
);

export default AreaGraph;
